import { render, staticRenderFns } from "./SolicitacaoReceita.vue?vue&type=template&id=b3bd8986&scoped=true"
import script from "./SolicitacaoReceita.vue?vue&type=script&lang=js"
export * from "./SolicitacaoReceita.vue?vue&type=script&lang=js"
import style0 from "./SolicitacaoReceita.vue?vue&type=style&index=0&id=b3bd8986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bd8986",
  null
  
)

export default component.exports